import React, { useState } from 'react';
import { apiRequest } from '../../utils/apiConfig';
import './CommandPanel.scss';

const CommandPanel = () => {
    const [command, setCommand] = useState('');
    const [result, setResult] = useState('Command output will appear here...');
    const [resultClass, setResultClass] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const sendCommand = async () => {
        const trimmedCommand = command.trim();
        if (!trimmedCommand) {
            setResult('Please enter a command.');
            setResultClass('error');
            return;
        }

        setIsLoading(true);
        setResult('Sending command...');
        setResultClass('');

        try {
            const response = await apiRequest('/command', {
                method: 'POST',
                body: JSON.stringify({ command: trimmedCommand })
            });

            const data = await response.json();
            setResult(`Command sent successfully!\n\nOutput: ${data.output || '(no output)'}`);
            setResultClass('success');
            setCommand(''); // Clear input on success
        } catch (err) {
            setResult(`Network error: ${err.message}`);
            setResultClass('error');
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            sendCommand();
        }
    };

    return (
        <div className="command-panel">
            <h2>Send RCON Command</h2>
            <div className="command-form">
                <input
                    type="text"
                    className="command-input"
                    placeholder="Enter Minecraft command (e.g., say Hello World)"
                    value={command}
                    onChange={(e) => setCommand(e.target.value)}
                    onKeyPress={handleKeyPress}
                    disabled={isLoading}
                />
                <button
                    className="send-button"
                    onClick={sendCommand}
                    disabled={isLoading}
                >
                    {isLoading ? 'Sending...' : 'Send Command'}
                </button>
            </div>
            <div className={`command-result ${resultClass}`}>
                {result}
            </div>
        </div>
    );
};

export default CommandPanel;